import { MembershipPackage } from '@citruscamps/citrus-client'
import React from 'react'
import { Props } from 'react-select'
import { DefaultSearchPagination } from '../../constants/pagination'
import {
  DefaultMembershipPackageFetchProps,
  MembershipPackageFetchProps,
  useFetchInfiniteMembershipPackages,
} from '../../hooks/useFetchMemberPackages'
import { SearchableMultiSelect } from '../SearchableSelect/SearchableSelect'
import { MembershipPackSelectOption } from './components/MembershipPackSelectOption'

interface PackageOptionType {
  value: MembershipPackage
  label: React.JSX.Element
}

type UsedKeys = 'inputId' | 'onBlur'
interface IProps extends Pick<Props<PackageOptionType, true>, UsedKeys> {
  values?: string[]
  programId?: string
  isInline?: boolean
  hasError?: boolean
  fetchProps?: MembershipPackageFetchProps
  onBlur?: (e: React.FocusEvent<any, Element>) => void
  onSelect?: (val: MembershipPackage[]) => Promise<void> | void
}

export const MembershipPackMultiSelect = ({
  programId,
  values: initialValues = [],
  isInline = false,
  hasError = false,
  fetchProps = DefaultMembershipPackageFetchProps,
  onSelect: handleSelect,
  onBlur: handleBlur,
  ...props
}: IProps) => {
  const values = useFetchInfiniteMembershipPackages({
    programId,
    fetchProps: {
      ...fetchProps,
      query: {
        ...fetchProps.query,
        id: initialValues,
      },
    },
    fetchAll: true,
    isEnabled: initialValues.length > 0,
  })

  const excludeIds = fetchProps?.query?.exclude_id || initialValues
  const searchValues = useFetchInfiniteMembershipPackages({
    programId,
    fetchProps: {
      ...fetchProps,
      query: {
        ...fetchProps.query,
        exclude_id: excludeIds && excludeIds.length > 0 ? excludeIds : undefined,
      },
    },
    pagination: DefaultSearchPagination,
  })
  return (
    <SearchableMultiSelect
      {...props}
      controlShouldRenderValue={isInline}
      itemName="membership packages"
      values={values}
      searchValues={searchValues}
      initialCount={initialValues.length}
      hasError={hasError}
      mapToOption={(item, { view, controlShouldRenderValue }) => ({
        value: item,
        key: item.id,
        label: (
          <MembershipPackSelectOption
            pack={item}
            isDropdown={view === 'option'}
            isInline={controlShouldRenderValue}
          />
        ),
      })}
      onSelect={(val: MembershipPackage[]) => {
        handleSelect?.(val)
      }}
    />
  )
}
